import { Component, inject, input } from '@angular/core';
import { DecisionEnum } from '../application/data-transmission/data-transmission.model';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent, NoValue, PopinTriggerComponent } from '@tribeauto/ngx-mobilite-material';
import { StepComponent } from '../../graphic/atom/step/step.component';
import { Step } from '../stepper/stepper.model';
import { ApplicationStore } from '../application/application-store.service';
import { isCreditModerne } from '../helpers/society.helper';
import { DecisionErrorComponent } from './decision-error/decision-error.component';

@Component({
  selector: 'fol-decision',
  imports: [TranslatePipe, IconComponent, PopinTriggerComponent, StepComponent, DecisionErrorComponent],
  templateUrl: './decision.component.html',
  styleUrl: './decision.component.scss'
})
export class DecisionComponent {
  private readonly applicationStore = inject(ApplicationStore);

  decision = input<DecisionEnum | NoValue>(null);
  steps = input<Step[]>([]);
  validatedSteps = input<Step[]>([]);

  protected isCreditModerne = isCreditModerne(this.applicationStore.instant('pointOfSale')?.societyCode);
  protected translationKeySuffix = this.isCreditModerne ? '-credit-moderne' : '';

  protected readonly DECISION_ENUM = DecisionEnum;
  protected readonly STEP = Step;
}
